/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface AdvertisingCampaignCategoryRowData
 */
export interface AdvertisingCampaignCategoryRowData {
    /**
     * 
     * @type {string}
     * @memberof AdvertisingCampaignCategoryRowData
     */
    campaignId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingCampaignCategoryRowData
     */
    campaignName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingCampaignCategoryRowData
     */
    category?: string;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingCampaignCategoryRowData
     */
    spend?: MoneyOutput;
}

/**
 * Check if a given object implements the AdvertisingCampaignCategoryRowData interface.
 */
export function instanceOfAdvertisingCampaignCategoryRowData(value: object): value is AdvertisingCampaignCategoryRowData {
    return true;
}

export function AdvertisingCampaignCategoryRowDataFromJSON(json: any): AdvertisingCampaignCategoryRowData {
    return AdvertisingCampaignCategoryRowDataFromJSONTyped(json, false);
}

export function AdvertisingCampaignCategoryRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvertisingCampaignCategoryRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'campaignId': json['campaignId'] == null ? undefined : json['campaignId'],
        'campaignName': json['campaignName'] == null ? undefined : json['campaignName'],
        'category': json['category'] == null ? undefined : json['category'],
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
    };
}

export function AdvertisingCampaignCategoryRowDataToJSON(json: any): AdvertisingCampaignCategoryRowData {
    return AdvertisingCampaignCategoryRowDataToJSONTyped(json, false);
}

export function AdvertisingCampaignCategoryRowDataToJSONTyped(value?: AdvertisingCampaignCategoryRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'campaignId': value['campaignId'],
        'campaignName': value['campaignName'],
        'category': value['category'],
        'spend': MoneyOutputToJSON(value['spend']),
    };
}

